(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delagos-premium-home"] && !Shopify.designMode) return;
  try {
    
function dphInit(root){
  if(!root)return;
  const tabs=root.querySelectorAll('[data-tab]');
  const panels=root.querySelectorAll('[data-panel]');
  tabs.forEach((btn)=>{
    btn.addEventListener('click',()=>{
      const key=btn.dataset.tab;
      tabs.forEach((b)=>b.classList.toggle('is-active',b===btn));
      panels.forEach((p)=>p.hidden=p.dataset.panel!==key);
    });
  });
}
document.querySelectorAll('[data-dph-tabs]').forEach(dphInit);
document.addEventListener('shopify:section:load',(e)=>dphInit(e.target.querySelector('[data-dph-tabs]')));

  } catch(e) { console.error(e); }
})();
})();
